__turbopack_context__.v({
  "container": "Slider-module-scss-module__Yp6MHG__container",
  "slider": "Slider-module-scss-module__Yp6MHG__slider",
});
